
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IAppNotification } from '@/types/notifications.types';
import NotificationsList from './NotificationsList.vue';
import NotificationDetailModal from './NotificationDetailModal.vue';

@Component({
    name: 'NotificationsView',
    components: { NotificationsList, NotificationDetailModal }
})
export default class NotificationsView extends Vue {

    selectedNotification: IAppNotification | null = null;
    modalOpen: boolean = false;

    async mounted() {
        await this.$store.dispatch('notifications/fetchNotifications');
    }

    openDetail(notification: IAppNotification): void {
        this.selectedNotification = notification;
        this.modalOpen = true;
    }

    onDeleted(): void {
        this.modalOpen = false;
        this.selectedNotification = null;
    }

}
